class CategorySlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.initialize();
    window.addEventListener(
      'resize',
      debounce(() => {
        if (this.slider) this.slider.destroy();
        this.initialize();
      }, 200)
    );
  }

  initialize() {
    const options = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      prevNextButtons: true,
      groupCells: 1,
      dragThreshold: 8,
    };
    this.slider = new Flickity(this, options);
  }
}

customElements.define('category-slider', CategorySlider);
